<template>
  <div class="box_69 flex-col">
    <div class="box_70 flex-row justify-between">
      <span class="text_37"><img class="hotlist-title-img" referrerpolicy="no-referrer" :src="require('../assets/img/hotlist_title.png')" /></span>
      <div class="group_6 flex-col"></div>
    </div>
    <div class="box_71">
      <div class="box_14 flex-col"></div>
      <div class="hotlist-rows">
        <a class="hotlist-row" v-for="(item, index) in hotList" :key="'hot'+index" :href="`/zp/a/${item.newsCode}`" target="_blank">
          <span class="row-text">{{ item.title }}</span>
          <span class="row-time">{{ formatRelativeTime(item.publishTime) }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../api/request'

export default {
  name: 'HotList',
  data() {
    return {
      // 热点榜数据列表
      hotList: []
    }
  },
  created() {
    // 组件创建时自动加载热点榜，无需外部传参
    this.fetchHotList()
  },
  methods: {
    // 加载热点榜：不传递任何参数
    async fetchHotList() {
      try {
        const params = {}
        const categoryId = this.$route.query.categoryId
        if (categoryId) {
          params.categoryId = categoryId
        }
        const res = await request.post('/api/news/hotList', params)
        const data = res.data
        const list = Array.isArray(data) ? data : (data.rows || data.list || data.records || [])
        this.hotList = list
      } catch (e) {
        console.error('热点榜加载失败', e)
      }
    },
    // 相对时间格式化
    formatRelativeTime(time) {
      if (!time) return ''
      const now = Date.now()
      const t = typeof time === 'string' ? new Date(time.replace(/-/g, '/')).getTime() : new Date(time).getTime()
      if (isNaN(t)) return time
      const diff = Math.floor((now - t) / 1000)
      if (diff < 60) return '刚刚'
      if (diff < 3600) return Math.floor(diff / 60) + '分钟前'
      if (diff < 86400) return Math.floor(diff / 3600) + '小时前'
      if (diff < 2592000) return Math.floor(diff / 86400) + '天前'
      const d = new Date(t)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.box_69 { width: 326px; }
.box_70 { width: 321px; height: 30px; margin-top: 46px; }
.text_37 {
  width: auto; height: 30px;
  display: flex; align-items: center;
}
.hotlist-title-img {
  height: 50px; width: auto;
}
.group_6 {
  width: 250px; height: 1px;
  border: 1px dashed rgba(216, 216, 216, 1); margin-top: 21px;
}
.box_71 { display: flex; flex-direction: row; width: 319px; margin: 23px 0 0 6px; overflow: visible; position: relative;margin-left: 0px; }
.box_14 { display: none; }
.hotlist-rows { flex: 1; margin-left: 0; position: relative; }
.hotlist-rows::before {
  content: '';
  position: absolute;
  left: 5.5px;
  top: 0;
  bottom: 0;
  border-left: 1px dashed rgba(216, 216, 216, 1);
}
.hotlist-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 0;
  /* border-bottom: 1px solid rgba(240, 240, 240, 1); */
  overflow: visible;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  position: relative;
  padding-left: 0;
  margin-left: -2px;
}
.hotlist-row::before {
  content: '';
  position: absolute;
  left: 0;
  top: 20px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #FFFFFF;
  border: 1px solid #979797;
  flex-shrink: 0;
  z-index: 1;
  margin-top: -6.5px;
}
.hotlist-row:hover .row-text {
  color: rgba(229, 1, 19, 1);
}
.hotlist-row:last-child {
  border-bottom: none;
}
.row-text {
  flex: 1;
  min-width: 0;
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 8px;
  padding-left: 17px;
  margin-left: 6px;
}
.row-time {
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  font-family: Microsoft YaHei UI-Regular;
  white-space: nowrap;
  line-height: 22px;
  flex-shrink: 0;
  text-align: right;
  margin: 5px;
  margin-top: 0px;
}
</style>
